export class CoverageCalculator {
  static calculateCoverage(person, capability) {
    if (!person.skills || !capability.required_skills) {
      return 0;
    }

    const personSkills = new Set(person.skills);
    const requiredSkills = capability.required_skills;
    
    const matchingSkills = requiredSkills.filter(skill => 
      personSkills.has(skill)
    );

    return Math.round((matchingSkills.length / requiredSkills.length) * 100);
  }

  static getMissingSkills(person, capability) {
    if (!person.skills || !capability.required_skills) {
      return capability.required_skills || [];
    }

    const personSkills = new Set(person.skills);
    return capability.required_skills.filter(skill => 
      !personSkills.has(skill)
    );
  }

  static getMatchingSkills(person, capability) {
    if (!person.skills || !capability.required_skills) {
      return [];
    }

    const personSkills = new Set(person.skills);
    return capability.required_skills.filter(skill => 
      personSkills.has(skill)
    );
  }

  static getAllSkills(people, capabilities) {
    const skillsSet = new Set();
    
    // Add skills from people
    people.forEach(person => {
      if (person.skills) {
        person.skills.forEach(skill => skillsSet.add(skill));
      }
    });

    // Add skills from capabilities
    capabilities.forEach(capability => {
      if (capability.required_skills) {
        capability.required_skills.forEach(skill => skillsSet.add(skill));
      }
    });

    return Array.from(skillsSet).sort();
  }

  static getAllCertifications(people, capabilities) {
    const certsSet = new Set();
    
    // Add certifications from people
    people.forEach(person => {
      if (person.certifications) {
        person.certifications.forEach(cert => certsSet.add(cert));
      }
    });

    // Add recommended certifications from capabilities
    capabilities.forEach(capability => {
      if (capability.recommended_certifications) {
        capability.recommended_certifications.forEach(cert => certsSet.add(cert));
      }
    });

    return Array.from(certsSet).sort();
  }

  static getTeamCoverage(people, capability) {
    if (!people.length || !capability.required_skills) {
      return 0;
    }

    const allTeamSkills = new Set();
    people.forEach(person => {
      if (person.skills) {
        person.skills.forEach(skill => allTeamSkills.add(skill));
      }
    });

    const coveredSkills = capability.required_skills.filter(skill => 
      allTeamSkills.has(skill)
    );

    return Math.round((coveredSkills.length / capability.required_skills.length) * 100);
  }

  static getCoverageMatrix(people, capabilities) {
    return people.map(person => ({
      person,
      coverages: capabilities.map(capability => ({
        capability,
        coverage: this.calculateCoverage(person, capability),
        missingSkills: this.getMissingSkills(person, capability),
        matchingSkills: this.getMatchingSkills(person, capability)
      }))
    }));
  }
}